import { render, staticRenderFns } from "./AssignmentInfoEditButton.vue?vue&type=template&id=1984d10b&"
import script from "./AssignmentInfoEditButton.vue?vue&type=script&lang=js&"
export * from "./AssignmentInfoEditButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports